<template>
  <el-form ref="baseForm" :rules="rules" :model="fromData">
  <search-box @subSearch="subSearch" :fromData="fromData" style="margin:0 0 10px 0">
    <el-form-item class="item" label="资源名称：" prop="resourceName">
      <el-input  v-model="fromData.searchCriteria.resourceName" clearable placeholder="请输入资源名称"></el-input>
    </el-form-item>
  </search-box>
  </el-form>
</template>

<script>
import searchBox from 'components/common/search.vue';
export default{
  components:{
    searchBox
  },
  props:{
    fromData:Object
  },
  data(){
    return{
      rules: {
        resourceName:[{message: "",trigger: "blur"}],
      }
    }
  },
  methods:{
    //搜索
    subSearch(){
      this.$emit('subSearch');
    }
  }
}
</script>

<style>
</style>
